import { z } from 'zod';
import { readFile } from '@wix/cli-fs';
import { CliError, CliErrorCode } from '@wix/cli-error';

const translationsSchema = z.union([
  z.record(z.string()),
  z.record(z.record(z.string())),
]);

export type TranslationsData = z.infer<typeof translationsSchema>;

export async function readTranslationsFile(
  translationsFilePath: string
): Promise<TranslationsData> {
  const fileContent = await readFile(translationsFilePath, 'utf-8');

  let parsedContent: unknown;
  try {
    parsedContent = JSON.parse(fileContent);
  } catch (error) {
    throw new CliError({
      code: CliErrorCode.InvalidJsonFile({ filePath: translationsFilePath }),
      cause: error,
    });
  }

  const parseResult = translationsSchema.safeParse(parsedContent);
  if (!parseResult.success) {
    throw new CliError({
      code: CliErrorCode.InvalidTranslationsFileSchema({
        filePath: translationsFilePath,
        zodError: parseResult.error,
      }),
      cause: parseResult.error,
    });
  }

  return parseResult.data;
}
